import { Typeahead } from "react-bootstrap-typeahead";
import { Card, Col, CardBody, Form } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { PreFetchHeading } from "../../../../Constant";
import { PREFETCH, COUNTRY_LIST } from "../../../../Data/FormWidgets";

const PreFetch = () => {
  return (
    <Col sm="12" md="6">
      <Card>
        <CommonCardHeader title={PreFetchHeading} span={PREFETCH} />
        <CardBody>
          <div id="the-basics">
            <Form className="theme-form">
              <div>
                <Typeahead options={COUNTRY_LIST} placeholder="Countries" id="PreFetch"/>
              </div>
            </Form>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default PreFetch;
